<template id="child">
    <div class="">
        <div class="row">
            <div class="col-md-6 mb-4">
                <div class="form-group form__box p-0">

                    <ValidationProvider rules="required|alpha_spaces" v-slot="{ errors }" ref="first_name">
                        <input type="text" id="first_name" name="first_name" class="form-control form__input"
                               :class="{ 'is-invalid': errors && errors.length }" v-model="user.name"
                               :placeholder="__('messages.first_name')" @change="validateField('first_name')">
                        <label for="first_name" class="form__label">{{ __('messages.first_name') }}</label>
                        <span v-if="errors[0]" class="invalid-feedback">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-md-6 mb-4">
                <div class="form-group form__box p-0">
                    <ValidationProvider rules="required|alpha_spaces" v-slot="{ errors }" ref="last_name">
                        <input type="text" id="last_name" name="last_name" class="form-control form__input"
                               :class="{ 'is-invalid': errors && errors.length }" v-model="user.last_name"
                               :placeholder="__('messages.last_name')" @change="validateField('last_name')">
                        <label for="last_name" class="form__label">{{ __('messages.last_name') }}</label>
                        <span v-if="errors[0]" class="invalid-feedback">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12 mb-4">
                <div class="form-group form__box p-0">
                    <ValidationProvider rules="required|email" v-slot="{ errors }" vid="confirm" ref="email">
                        <input type="text" id="email" name="email" class="form-control form__input"
                               :class="{ 'is-invalid': errors && errors.length }" v-model="user.email"
                               :placeholder="__('messages.email')" @change="validateField('email')">
                        <label for="email" class="form__label">{{ __('messages.email') }}</label>
                        <span v-if="errors[0]" class="invalid-feedback">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12 mb-4">
                <div class="form-group form__box p-0">
                    <ValidationProvider rules="required|email|confirmed:confirm" v-slot="{ errors }"
                                        ref="email_confirmation">
                        <input type="text" id="email_confirmation" name="email_confirmation"
                               class="form-control form__input" :class="{ 'is-invalid': errors && errors.length }"
                               v-model="user.email_confirmation" :placeholder="__('messages.confirm_email')"
                               @change="validateField('email_confirmation')">
                        <label for="email_confirmation" class="form__label">{{ __('messages.confirm_email') }}</label>
                        <span v-if="errors[0]" class="invalid-feedback">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-md-6 mb-4">
                <div class="form-group form__box p-0">
                    <ValidationProvider rules="required|integer" v-slot="{ errors }" ref="phone">
                        <input type="tel" class="form-control form__input" id="phone"
                               :placeholder="__('messages.phone')" :class="{ 'is-invalid': errors && errors.length }"
                               v-model.number="user.phone" @change="validateField('phone')">
                        <label for="phone" id="tel-label" class="form__label phone__label">
                            {{
 __('messages.phone')
                            }}
                        </label>
                        <span v-if="errors[0]" class="text-danger mt-1">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>

            <div class="col-md-12 mt-2" v-if="provider === 1">
                <a class="border-0 text-dark text-left font-16 font-weight-500 bg-white px-0"
                   type="button" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false"
                   aria-controls="collapseExample">
                    <h6 class="font-16 d-inline-block">{{ __('messages.special_requests') }}</h6>
                    <i class="icons-chevron-down float-right ml-3"></i>
                </a>
            </div>
            <div class="collapse col-12" id="collapseExample">
                <div class="card card-body border-0 p-0 form-group form__box p-0">
                    <label class="mb-3" for="special_request">{{ __('messages.we_send_your_requests') }}</label>
                    <div>
                        <textarea class="form-control" id="special_request" rows="3" v-model="user.special_request"
                                  @keyup="onChangeSpecialRequest($event)" :maxlength="limitTextArea"
                                  :placeholder="__('messages.special_request_placeh')"></textarea>
                        <small class="float-right">{{ user.special_request.length }} / {{ limitTextArea }}</small>
                    </div>
                </div>
            </div>

            <div class="col-md-12 mt-2">
                <p class="m-0">
                    {{ __('messages.i_have_read') }} <a class="link d-inline" :href="'/'+ culture.cultureCode + __('url.url_terms')" target="_blank">
                        {{ __('messages.privacy_terms_and_reservation_police') }}
                    </a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import { storeToRefs } from 'pinia';
    import intlTelInput from 'intl-tel-input';
    import { ValidationProvider } from 'vee-validate';
    import { HotelAnalytic } from '../../analytics/HotelsAnalytics'
    import { useUserStore } from '../../stores/user';
    const site = window.__pt.settings.site;
    const culture = window.__pt.cultureData;
    const userLocation = window.__pt.userLocation;
    export default {
        components: {
            ValidationProvider
        },
        data() {
            return {
                culture,
                limitTextArea: 200,
                showSpecialRequest: culture.InternalCultureCode != "es-mx",
                isTextAreaOpen: false,
                formFields: ['first_name', 'last_name', 'email', 'email_confirmation', 'phone', 'policy_terms']
            }
        },
        props: ['user', 'provider', 'submitEvent'],
        setup() {
            const storeUserStore = useUserStore();

            const { getPhone, getDialPhone } = storeToRefs(storeUserStore);
            return { getPhone, getDialPhone }
        },
        async mounted() {
            this.onInit();

            $('[data-toggle="collapse"]').on('click', function () {
                if ($(this).attr('aria-expanded') == 'true') {
                    $(this).find('i').addClass('icons-chevron-down').removeClass('icons-chevron-down-1');
                } else {
                    $(this).find('i').addClass('icons-chevron-down-1').removeClass('icons-chevron-down');
                }
            });
        },
        watch: {
            submitEvent: {
                deep: false,
                handler() {
                    setTimeout(async () => {
                        for (const fieldName of this.formFields) {
                            await this.validateField(fieldName);
                        }
                    });
                },
            },
        },
        methods: {
            onInit() {
                const input = document.querySelector("#phone");
                let iti = intlTelInput(input, {
                    initialCountry: userLocation.country,
                    preferredCountries: site.preferredCountries
                });

                input.addEventListener("countrychange", () => {
                    const selected = iti.getSelectedCountryData();
                    if (selected) {
                        this.user.dial_code = selected.dialCode;
                    }
                });

                //var countryData = iti.getSelectedCountryData();

                
                const countryDataList = iti.countries || [];
                const match = countryDataList.find(c => +c.dialCode === this.getDialPhone);
                var countryData = iti.getSelectedCountryData();

                if (match) {
                    iti.setCountry(match.iso2);
                    this.user.dial_code = match.dialCode;
                } else {
                    iti.setCountry(countryData.iso2);
                    this.user.dial_code = countryData.dialCode;
                }

                //if (countryData) {
                //    this.user.dial_code = countryData.dialCode;
                //}

                let label = document.getElementById("tel-label");
                if (input) {
                    input.after(label)
                }
            },
            async validateField(field) {
                const provider = this.$refs[field];
                let result = await provider.validate();
                if (result && !result.valid) {
                    HotelAnalytic.trackUserError(field, result, this.__('messages.enter_your_data'))
                }
            },
            onChangeSpecialRequest(event) {
                if (this.user.special_request.length > this.limitTextArea) {
                    this.user.special_request = this.user.special_request.substring(0, this.limitTextArea);
                }
            }
        }
    }
</script>
